import { render, staticRenderFns } from "./BoxView.vue?vue&type=template&id=f789d5b8&scoped=true&"
import script from "./BoxView.vue?vue&type=script&lang=js&"
export * from "./BoxView.vue?vue&type=script&lang=js&"
import style0 from "./BoxView.vue?vue&type=style&index=0&id=f789d5b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f789d5b8",
  null
  
)

export default component.exports